import type { IconData } from '@stacksjs/iconify-core'

export const shareLink: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M45 36a9 9 0 1 1-18 0a9 9 0 0 1 18 0m0-24a9 9 0 1 1-18 0a9 9 0 0 1 18 0M21 24a9 9 0 1 1-18 0a9 9 0 0 1 18 0\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M21 24a9 9 0 1 1-18 0a9 9 0 0 1 18 0m24-12a9 9 0 1 1-18 0a9 9 0 0 1 18 0m0 24a9 9 0 1 1-18 0a9 9 0 0 1 18 0M27.948 16.025l-7.896 3.949m7.896 12l-7.896-3.949\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default shareLink
